<template>
  <div class="wrapper">
    <!-- <TopTabbar :hastitle="true" title="全部订单" /> -->
    <div class="title-top">
      <i class="iconfont iconarrowRight-copy" @click="$router.go(-1)"></i>
      <span>全部订单</span>
      <div class="screening" @click="pop_up">
        <span ref="scr">{{ screening }}</span>
        <i><van-icon name="arrow-down"/></i>
      </div>
      <van-field
        :value="shape_code"
        @focus="focusMobile"
        center
        clearable
        placeholder="请输入商品条码"
        class="input"
      >
        <template #button>
          <van-button size="small" @click="search">搜索</van-button>
        </template>
      </van-field>
    </div>
    <van-dialog
      v-model="show"
      title="筛选"
      :showConfirmButton="showConfirmButton"
    >
      <!-- <div class="screening_Item">
        <span>全部</span>
        <i><van-icon name="arrow-up"/></i>
      </div>
      <div class="screening_List">
        123
      </div> -->
      <div style="position:relative">
        <van-icon class="down-icon" name="arrow-down"/>
        <select @change="screeningChange" name="" id="">
          <option
            v-for="(item, index) of option"
            :key="index"
            :value="item.text"
            >{{ item.text }}</option
          >
        </select>
      </div>
      <div class="btn_box">
        <van-button @click="confirm">确定</van-button>
        <van-button
          style="float:right; background: #201F26;"
          @click="show = false"
          >取消</van-button
        >
      </div>
    </van-dialog>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div
        v-for="(item, index) in list"
        :key="item.order_id"
        class="item"
        @click="pushDetail(item.order_id)"
      >
        <div class="title">
          <span>订单号：{{ item.order_no }}</span>
          <span class="time ">{{ item.create_time }}</span>
          <!-- <span class="state end" v-if="item.pay_status.value === 10"
                        >付款状态:{{ item.pay_status.text }}</span
                    >
                    <span class="state not" v-else
                        >付款状态:{{ item.pay_status.text }}</span
                    > -->

          <span class="state right">订单状态:{{ item.order_status.text }}</span>
        </div>

        <div class="content">
          <div
            v-for="(imgs, index) in item.goods"
            :key="imgs.goods_id"
            v-show="index < 5"
          >
            <img
              v-if="imgs.image"
              :src="imgs.image.file_path"
              alt=""
              class="img"
            />
            <img
              src="@/assets/img/291b5ccba3708665eeecc427fafd6da.png"
              v-else
            />
          </div>

          <!-- <div class="info">
                        <div class="name">{{ item.goods[0].goods_name }}</div>
                        <div class="material">
                            <span>产品编号:</span>{{ item.goods[0].goods_no }}
                        </div>
                        <div class="material">
                            <span>克重(g):</span>
                            {{ item.goods[0].goods_weight }}
                        </div>
                        <div class="goods_price">
                            <span>￥</span>{{ item.goods[0].total_price }}
                        </div>
                        <div class="user_phone" v-if="item.user_phone">
                            <span>用户电话:</span>{{ item.user_phone }}
                        </div>
                    </div> -->
        </div>

        <div class="goods-number">
          <div class="number">共{{ item.goods.length }}件</div>
          <i class="iconfont iconarrowRight"></i>
        </div>

        <!-- <div class="price">
                    <span>合计：</span>
                    <span class="pay_price">{{ item.pay_price }}</span>
                </div> -->

        <div class="operation">
          <div class="btn-wra">
            <!-- <div class="btn" @click="orderStatus(item, index)">
                            修改订单状态
                        </div> -->
            <div
              v-if="
                item.order_status.value !== 30 && item.order_status.value !== 20
              "
            >
              <div
                class="btn"
                @click.stop="orderCancel(item, index)"
                v-if="item.order_status.value !== 21"
              >
                申请取消
              </div>
              <div v-else class="tips">取消申请中</div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <van-popup v-model="showPop" @close="closePop">
      <div class="pop">
        <div class="title">修改订单状态</div>
        <div class="payState">选择订单状态</div>

        <div class="select">
          {{ payState }}
          <!-- <i class="iconfont iconshangjiantou" @click="showOPtions" ></i> -->
          <i class="iconfont iconshangjiantou down" @click="showOPtions"></i>
        </div>
        <div class="option" v-show="showOPtion" @click="accountPaid">
          已付款
        </div>
        <div class="option" v-show="showOPtion" @click="endPaid">
          待付款
        </div>
        <div class="btn-wra">
          <div class="btn" @click="showPop = false">取消</div>
          <div class="btn" @click="changeState">确定</div>
        </div>
      </div>
    </van-popup>
    <van-number-keyboard
      title="输入商品条码"
      @input="onInput"
      @delete="deleteMobile"
      close-button-text="关闭"
      :show="showMobileKey"
      @blur="showMobileKey = false"
    />
  </div>
</template>

<script>
import TopTabbar from "@/components/TopTabbar.vue";
import { orderList, orderStatus, orderCancel } from "../../api/http.js";
// import vSelect from "vue-select";
// import "vue-select/dist/vue-select.css";
import { Dialog } from "vant";

export default {
  components: {
    TopTabbar
    // vSelect,
  },

  data() {
    return {
      test: true,
      show: false,
      list: [],
      loading: false,
      finished: false,
      showPop: false,
      showOPtion: false,
      payState: "",
      currentItem: "",
      page: 0,
      shape_code: "",
      showMobileKey: false,
      screening: "全部",
      showConfirmButton: false,
      option: [
        { text: "全部", query_date: "" },
        { text: "三个月内", query_date: "three_month" },
        { text: "六个月内", query_date: "six_month" },
        { text: "一年内", query_date: "this_year" }
      ],
      temp: "全部",
      query_date: ""
    };
  },

  methods: {
    pop_up() {
      this.show = !this.show;
    },
    confirm() {
      this.screening = this.temp;
      switch (this.screening) {
        case "三个月内":
          this.query_date = "three_month";
          break;
        case "六个月内":
          this.query_date = "six_month";
          break;
        case "一年内":
          this.query_date = "this_year";
          break;
      }
      this.show = false;
      this.page = 1;
      this.list = [];
      this.getList(this.page, this.query_date);
    },
    screeningChange(e) {
      this.temp = e.target.value;
    },
    onLoad() {
      console.log("dd");
      this.page++;
      this.getList(this.page);
    },

    search() {
      this.page = 1;
      this.list = [];
      this.getList(this.page);
    },

    getList(page) {
      console.log(page);
      let token = localStorage.getItem("login_token");
      orderList(page, token, this.shape_code, this.query_date).then(res => {
        console.log(res);
        this.list = this.list.concat(res.data.list.data);
        this.loading = false;
        if (res.data.list.data.length < 15) {
          this.finished = true;
        }
      });
    },

    orderStatus(item, index) {
      this.currentItem = item;
      this.payState = item.pay_status.text;
      this.showPop = true;
    },

    orderCancel(item, index) {
      Dialog.confirm({
        title: "是否取消订单？",
        width: "40%"
      })
        .then(() => {
          let token = localStorage.getItem("login_token");
          orderCancel(item.order_id, token).then(res => {
            // this.$toast("取消成功");
            this.list[index].order_status.value = 21;
            // this.list.splice(index, 1);
          });
        })
        .catch(() => {
          // on cancel
        });
    },

    showOPtions() {
      this.showOPtion = !this.showOPtion;
    },

    accountPaid() {
      this.payState = "已付款";
      this.showOPtion = false;
    },

    endPaid() {
      console.log("fff");
      this.payState = "待付款";
      this.showOPtion = false;
    },

    changeState() {
      let token = localStorage.getItem("login_token");
      let status;
      if (this.payState === "已付款") {
        status = 20;
      } else {
        status = 10;
      }
      orderStatus(this.currentItem.order_id, status, token).then(res => {
        this.currentItem.pay_status.value = status;
        this.currentItem.pay_status.text = this.payState;
        this.$toast("修改成功");
        this.showPop = false;
      });
    },

    closePop() {
      this.showOPtion = false;
    },

    focusMobile() {
      document.activeElement.blur();
      this.showMobileKey = true;
    },

    deleteMobile() {
      if (this.shape_code) {
        let keys = this.shape_code.slice(0, this.shape_code.length - 1);
        this.shape_code = keys;
      }
    },
    onInput(key) {
      if (this.shape_code.length > 10) {
        return;
      }
      let keys = String(key);
      this.shape_code = this.shape_code.concat(keys);
    },

    pushDetail(id) {
      this.$router.push({
        path: "/orderDetail",
        query: {
          id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.down-icon{
  position:absolute;
  right:15px;
  font-size:20px;
  top:50%;
  transform: translateY(-50%);
}
select {
  background: #fff;
  font-size: 16px;
  text-indent: 20px;
  display: block;
  width: 100%;
  height: 55px;
  margin: 40px auto 0;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
}
.screening_Item {
  height: 56px;
  width: 332px;
  border: 1px solid #8b8b8b;
  margin: 60px auto 0;
  position: relative;
  span {
    line-height: 56px;
    margin-left: 16px;
    font-weight: 700;
  }
  i {
    font-size: 25px;
    line-height: 56px;
    position: absolute;
    right: 10px;
    color: #8b8b8b;
  }
}
.screening_List {
  width: 332px;
  margin: 0 auto;
  background: red;
}
.screening {
  position: absolute;
  top: 0;
  right: 32%;
  width: 85px;
  height: 30px;
  font-size: 12px;
  background: #f1f1f1;
  line-height: 30px;
  margin-top: 7px;
  span {
    display: inline-block;
    margin-right: 20px;
  }
  i {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    right: 3px;
    font-weight: 700;
    font-size: 14px;
    margin-left: 3px;
  }
}
.wrapper {
  background-color: #e3e1e1;
  padding-top: 44px;
  min-height: 100vh;
}
/deep/.van-dialog {
  width: 40%;
}
.title-top {
  position: fixed;
  top: 0;
  left: 0;
  height: 44px;
  z-index: 9999;
  width: 100%;
  background-color: #fff;
  text-align: center;
  line-height: 44px;
  font-size: 16px;
  .iconfont {
    position: absolute;
    left: 2%;
    top: 50%;
    transform: translateY(-50%);
  }
  .input {
    position: absolute;
    right: 2%;
    width: 300px;
    top: 4px;
    height: 40px;
    // border-bottom: 1px solid #e3e1e1;
    /deep/.van-field__control {
      background-color: #f7f8fa;
    }
  }
}
.pop {
  width: 380px;
  height: 320px;
  background-color: #fff;
  border-radius: 4px;
  padding: 23px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  .title {
    font-size: 16px;
    font-weight: 300;
    text-align: center;
  }
  .payState {
    color: #8b8b8b;
    margin-top: 35px;
    margin-bottom: 10px;
    font-size: 12px;
  }
  .select {
    width: 300px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #8b8b8b;
    position: relative;
    font-size: 12px;
    padding-left: 10px;
    z-index: 999;
    .iconfont {
      font-size: 15px;

      position: absolute;
      top: 50%;
      right: 3%;
      transform: translateY(-50%);
    }
    .down {
      transform: translateY(-50%) rotate(180deg);
    }
  }
  .option {
    width: 300px;
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    border-bottom: 1px solid #8b8b8b;
    font-size: 12px;
    z-index: 999;
  }
  .btn-wra {
    display: flex;
    justify-content: space-around;
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100%;
    // height: 35px;
    .btn {
      width: 160px;
      height: 30px;
      background: #000000;
      border-radius: 4px;
      color: #fff;
      line-height: 30px;
      text-align: center;
      margin-top: 70px;
      font-size: 12px;
    }
  }
}
.item {
  width: 100%;
  margin-top: 7px;
  background-color: #fff;
  padding: 14px 10px;
  box-sizing: border-box;
  position: relative;
  .title {
    font-size: 12px;
    position: relative;
    .time {
      color: #3f3f3f;
      font-size: 12px;
      margin-left: 5px;
    }
    .state {
      margin-left: 28px;
      font-size: 14px;
      font-weight: 500;
    }
    .end {
      color: #b90b0b;
    }
    .not {
      color: #3c941a;
    }
    .right {
      position: absolute;
      right: 3%;
    }
  }
  .content {
    display: flex;
    margin-top: 10px;
    margin-bottom: 20px;
    min-height: 120px;
    .img {
      background:#000;
      width: 120px;
      height: 120px;
      border-radius: 4px;
      margin-right: 18px;
    }
    .info {
      color: #191919;
      font-size: 13px;
      font-weight: 400;
      .name {
        font-weight: 600;
        margin-bottom: 10px;
      }
      .material {
        margin-bottom: 9px;

        span {
          color: #747474;
        }
      }
      .goods_price {
        font-size: 16px;
        span {
          font-size: 12px;
        }
      }
      .user_phone {
        margin-top: 12px;
        span {
          color: #747474;
        }
      }
    }
  }
  .goods-number {
    position: absolute;
    right: 10px;
    bottom: 40%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    .number {
      font-size: 14px;
      font-weight: 300;
      color: #8b8b8b;
    }
    .iconfont {
      font-size: 16px;
    }
  }
  .price {
    position: absolute;
    left: 10px;
    bottom: 10px;
    font-weight: 600;
    font-size: 14px;
    text-align: right;
    padding-right: 8px;
    color: #8b8b8b;
    .pay_price {
      font-size: 16px;
      margin-left: 3px;
      color: #000000;
    }
  }
  .operation {
    position: absolute;
    right: 10px;
    bottom: 14px;

    .btn-wra {
      display: flex;
      margin-top: 8px;
      .btn {
        width: 130px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border: 1px solid #202020;
        border-radius: 4px;
        margin-right: 6px;
        font-size: 12px;
      }
      .tips {
        font-size: 16px;
        width: 130px;
        text-align: center;
      }
    }
  }
}
</style>
<style lang="scss">
.wrapper {
  .van-dialog {
    box-sizing: border-box;
    padding: 0 30px;
    width: 380px;
    height: 240px;
    .van-button {
      width: 160px;
      height: 40px;
      background: #000;
      margin-top: 30px;
      color: #fff;
    }
    .van-dialog__footer--buttons {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
}
</style>
